import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { core } from '@/lib/core';
import { AddonContent } from '@/lib/addon-content';

export function useCatalogClient(profileId: string | undefined, scope: string) {
  const [state, setState] = useState<{scope:string;client:AddonContent}>();
  useEffect(() => {
    if (!profileId || !scope) { setState(undefined); return; }
    // Own each lifetime inside the effect: StrictMode cleanup cannot retire a
    // memoized instance which a replay then accidentally reuses.
    const client=new AddonContent(profileId,api,(addon,meta,signal)=>core<boolean>({action:'supports',
      manifest:addon.manifest,resource:'meta',type:meta.type,id:meta.id},signal));
    setState({scope,client});
    return () => client.close();
  },[profileId,scope]);
  return state?.scope===scope?state.client:undefined;
}
